import React, { useState } from 'react';

const Offer = ({item, filtered, searchOn, close}) => {
    
    const [showInfo, setShowInfo] = useState(false)
    const [selectedKey, setSelectedKey] =useState()

    const offerHandler = () => {
        if(!showInfo) {
            setShowInfo(true)
            window.scrollTo(0, 0)
        } else {
            setShowInfo(false)
        }
    }


   

  
    return (
        <>
       
                        <div className="offer" key={item.INTITULE + item.ID}>
                           <div className="info">
                                <h2>{item.INTITULE}</h2>     
                                <h4>Organisme :</h4>     
                                <span>{item.STRUCTURE}</span>
                                <h4>Type de Contrat : </h4>
                                <span>{item.CONTRAT}</span> 
                            </div>
                           <button className='seeMore' onClick={offerHandler}>Voir plus</button>
                                { showInfo === true ? (                
                                <div className="showInfo">      
                                    <button className="close" onClick={offerHandler}>{close}</button>
                                  <div className="offerFullHeight" key={selectedKey}>
                                    <h2>{item.INTITULE}</h2>     
                                    <h4>Organisme :</h4>     
                                    <span>{item.STRUCTURE}</span>
                                    <h4>Type de Contrat : </h4>
                                    <span>{item.CONTRAT}</span> 
                                    <div className="mission">
                                        <h4>La Mission :</h4>  
                                        <p>{item.MISSION}</p>
                                    </div>  
                                    <h4>Compétences requises :</h4>     
                                    <span>{item.COMPETENCES}</span> 
                                    <h4>Conditions Particulières : </h4>    
                                    <span>{item.CONDITIONS}</span> 
                                    <h4>Contact : </h4>     
                                    <span className='contact'>{item.CONTACT}</span>  
                                </div>
                            </div> ) : ""}
                        </div>
              
                    
        </>
    );
};

export default Offer;